module.exports = __webpack_public_path__ + "img/recruitingBanner.a43231e8.png";